import { Typography, makeStyles } from "@material-ui/core";

import React from "react";
import { useTranslate } from "ra-core";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    fontWeight: "bold",
  },
}));
const CannotViewField = ({ resource, source, bind = "default" }) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Typography variant="body2" className={classes.root}>
      {translate(
        `resources.technical-report-evals.cannot_view.${resource}.${source}.${bind}`
      )}
    </Typography>
  );
};

export default CannotViewField;
